import React, { useEffect, useState } from "react";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import group51 from "../../assets/group-5-1.svg";
import { base_url } from "../../Global";

const Content = () => {
  const [media, setMedia] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [checkedItems, setCheckedItems] = useState([]);
  const [reloadComponent, setReloadComponent] = useState(false);

  const notify = () => toast.success("Content deleted successfully!");

  const handleCheckboxChange = (event, id) => {
    if (event.target.checked) {
      setCheckedItems([...checkedItems, id]);
    } else {
      setCheckedItems(checkedItems.filter((item) => item !== id));
    }
  };

  async function deleteMultipleMedia() {
    try {
      const accessToken = localStorage.getItem("accessToken");
      if (!accessToken) throw new Error("Access token not found");
      const response = await fetch(base_url + "/delete-multiple-media", {
        method: "DELETE",
        headers: {
          "Content-Type": "application/json",
          authorization: accessToken,
        },
        body: JSON.stringify({ checkedItems }),
      });
      if (response.ok) {
        setReloadComponent(!reloadComponent);
        setCheckedItems([]);
        notify();
      }
    } catch (error) {
      console.error("Error deleting multiple media:", error);
    }
  }

  useEffect(() => {
    async function fetchMediaFeed() {
      try {
        const accessToken = localStorage.getItem("accessToken");
        if (!accessToken) throw new Error("Access token not found");
        const response = await fetch(base_url + "/entity/feed", {
          headers: {
            "Content-Type": "application/json",
            authorization: accessToken,
          },
        });
        if (!response.ok) throw new Error("Failed to fetch media feed");
        const data = await response.json();
        setMedia(data.allMedia);
      } catch (error) {
        setError(error.message);
      } finally {
        setLoading(false);
      }
    }
    fetchMediaFeed();
  }, [reloadComponent]);

  const handleDeleteMedia = async (mediaId) => {
    try {
      const response = await fetch(base_url + `/entity/delete/${mediaId}`, {
        method: "GET",
      });
      if (response.ok) {
        setReloadComponent(!reloadComponent);
        notify();
      }
    } catch (error) {
      console.error("Error deleting media:", error);
    }
  };

  if (loading) {
    return (
      <div style={{
        flex: 1,
        minHeight: "100vh",
        backgroundColor: "#374151",
        color: "white",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        fontSize: "18px",
      }}>
        Loading...
      </div>
    );
  }

  if (error) {
    return (
      <div style={{
        flex: 1,
        minHeight: "100vh",
        backgroundColor: "#374151",
        color: "white",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        fontSize: "18px",
      }}>
        Error: {error}
      </div>
    );
  }

  return (
    <div style={{
      flex: 1,
      minHeight: "100vh",
      backgroundColor: "#374151",
      color: "white",
      padding: "24px 16px",
      boxSizing: "border-box",
      overflowX: "hidden",
    }}>
      <ToastContainer className="text-[1rem]" />

      {/* ✅ HEADER */}
      <div style={{
        display: "flex",
        alignItems: "center",
        justifyContent: "space-between",
        flexWrap: "wrap",
        gap: "12px",
        marginBottom: "24px",
      }}>
        <h1 style={{
          margin: 0,
          fontSize: "clamp(1.25rem, 4vw, 2rem)",
          textTransform: "capitalize",
          fontWeight: 600,
        }}>
          Content
        </h1>

        {/* Delete selected button */}
        <button
          onClick={deleteMultipleMedia}
          style={{
            display: "flex",
            alignItems: "center",
            gap: "8px",
            padding: "10px 20px",
            backgroundColor: "white",
            border: "none",
            borderRadius: "8px",
            cursor: "pointer",
            fontSize: "15px",
            fontWeight: 500,
            color: "#1f2937",
          }}
        >
          <img src={group51} alt="delete" style={{ width: "14px", height: "16px" }} />
          Delete Selected
        </button>
      </div>

      {/* ✅ MEDIA GRID — 1 col mobile, 2 col tablet, 3 col desktop */}
      {media.length === 0 ? (
        <div style={{
          textAlign: "center",
          padding: "60px 20px",
          color: "#9ca3af",
          fontSize: "16px",
        }}>
          No content available.
        </div>
      ) : (
        <div style={{
          display: "grid",
          gridTemplateColumns: "repeat(auto-fill, minmax(280px, 1fr))",
          gap: "16px",
        }}>
          {media.map((item) => (
            <div
              key={item.id}
              style={{
                backgroundColor: "#1f2937",
                borderRadius: "8px",
                overflow: "hidden",
                boxShadow: "0 0 10px rgba(0,0,0,0.2)",
                display: "flex",
                flexDirection: "column",
              }}
            >
              {/* ✅ MEDIA PREVIEW */}
              <div style={{ position: "relative" }}>
                {item.entityType === "videos" ? (
                  <video
                    style={{ width: "100%", height: "200px", objectFit: "cover", display: "block" }}
                    loop
                    autoPlay
                    muted
                    src={item.url}
                  />
                ) : (
                  <img
                    style={{ width: "100%", height: "200px", objectFit: "cover", display: "block" }}
                    src={item.url}
                    alt={item.caption}
                  />
                )}

                {/* Checkbox — top left */}
                <input
                  type="checkbox"
                  id={item.id}
                  onChange={(e) => handleCheckboxChange(e, item.id)}
                  style={{
                    position: "absolute",
                    top: "10px",
                    left: "10px",
                    width: "22px",
                    height: "22px",
                    cursor: "pointer",
                  }}
                />

                {/* Type badge — bottom left */}
                <div style={{
                  position: "absolute",
                  bottom: "8px",
                  left: "8px",
                  backgroundColor: "rgba(55,65,81,0.85)",
                  backdropFilter: "blur(8px)",
                  color: "white",
                  padding: "5px 12px",
                  borderRadius: "6px",
                  fontSize: "13px",
                  textTransform: "capitalize",
                }}>
                  {item.entityType}
                </div>
              </div>

              {/* ✅ CONTENT INFO */}
              <div style={{
                padding: "12px 14px",
                display: "flex",
                flexDirection: "column",
                gap: "6px",
                flex: 1,
              }}>
                <div style={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "space-between",
                  gap: "8px",
                }}>
                  <h3 style={{
                    margin: 0,
                    fontSize: "15px",
                    fontWeight: 500,
                    textTransform: "capitalize",
                    overflow: "hidden",
                    textOverflow: "ellipsis",
                    whiteSpace: "nowrap",
                  }}>
                    {item.tags}
                  </h3>

                  {/* Delete icon */}
                  <button
                    onClick={() => handleDeleteMedia(item.id)}
                    style={{
                      background: "none",
                      border: "none",
                      cursor: "pointer",
                      color: "#ef4444",
                      fontSize: "16px",
                      flexShrink: 0,
                      padding: "4px",
                    }}
                    title="Delete"
                  >
                    🗑
                  </button>
                </div>

                <p style={{
                  margin: 0,
                  fontSize: "13px",
                  color: "#9ca3af",
                  overflow: "hidden",
                  textOverflow: "ellipsis",
                  whiteSpace: "nowrap",
                }}>
                  {item.caption}
                </p>
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

export default Content;